<template>
  <section class="container">
    <stockTopMenu
      :curPosition="$t('salesRecord.salesRecord')"
      windowId="salesRecord"
      module="money"
    ></stockTopMenu>
    <section
      class="row"
      v-loading="infoDetailLoading"
      :element-loading-text="$t('salesRecord.loadingText')"
      element-loading-spinner="el-icon-loading"
    >
      <asideContent
        ref="ording"
        invoicesType="2"
        @sendObj="getCurOrdingObj"
      ></asideContent>
      <section class="section-main" v-if="ordingId">
        <section style="background: #fff; padding: 20px 20px 10px">
          <tabsMenu
            v-if="tabList.length"
            :list="tabList"
            @curItem="getCurTab"
            :curTab="curTab"
          ></tabsMenu>
        </section>
        <section
          class="invoice-detail"
          id="goods-scroll"
          @scroll="scrollChange"
        >
          <!-- 原货品信息 -->
          <section id="tabcont0" class="invoice-card card-bottom">
            <div class="goods-top row align-center space-between">
              <div
                v-if="showList.afterSalesType !== '0'"
                class="row align-center"
              >
                <span class="title-label"></span>
                <p>
                  <span
                    style="
                      background: #f8475f;
                      color: #fff;
                      padding: 1px 4px;
                      border-radius: 4px;
                      font-size: 14px;
                      margin-right: 5px;
                    "
                    >{{$t('salesRecord.afterSales')}}</span
                  >
                  <span class="title-text">{{$t('salesRecord.goodsInfo')}}</span>
                  <span style="color: #999">（{{$t('salesRecord.afterSalesGoodsInfo')}}）</span>
                  <span
                    v-if="ordingData"
                    style="color: #000; margin-left: 20px">
                    {{$t('salesRecord.totalItems', {count: initCount || '0'})}}&nbsp;&nbsp;&nbsp;
                    {{$t('salesRecord.totalAmount')}}：{{ordingData ? ordingData.totalPrice : ""}}đ
                  </span>
                </p>
              </div>
              <div v-else class="row align-center">
                <span class="title-label"></span>
                <p>
                  <span
                    style="
                      background: #067cf2;
                      color: #fff;
                      padding: 1px 4px;
                      border-radius: 4px;
                      font-size: 14px;
                      margin-right: 5px;
                    "
                    >{{$t('salesRecord.original')}}</span
                  >
                  <span class="title-text">{{$t('salesRecord.goodsInfo')}}</span>
                  <span style="color: #999"
                    >（{{$t('salesRecord.originalGoodsInfo')}}）</span
                  >
                  <span v-if="ordingData" style="color: #000"
                    >{{$t('salesRecord.totalItems', {count: initCount || '0'})}}</span
                  >
                </p>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldOne')">
                <span v-if="unfoldObj.foldOne"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-if="unfoldObj.foldOne">
              <grid-manager
                v-if="goodsTable.length"
                :option="gridOption"
              ></grid-manager>
            </div>
          </section>
          <!-- 最新货品信息 -->
          <section
            v-if="newGoodsInfos.length"
            id="tabcont1"
            class="invoice-card card-bottom"
          >
            <div class="goods-top row align-center space-between">
              <div class="row align-center">
                <span class="title-label"></span>
                <p>
                  <span
                    style="
                      background: #f8475f;
                      color: #fff;
                      padding: 1px 4px;
                      border-radius: 4px;
                      font-size: 14px;
                      margin-right: 5px;
                    "
                    >{{$t('salesRecord.latest')}}</span
                  >
                  <span class="title-text">{{$t('salesRecord.expand')}}</span>
                  <span style="color: #999"
                    >（{{$t('salesRecord.latestGoodsInfo')}}）</span
                  >
                  <span v-if="currentCount" style="color: #000"
                    >{{$t('salesRecord.totalItems', {count: currentCount || '0'})}}</span
                  >
                </p>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldTwo')">
                <span v-if="unfoldObj.foldTwo"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-if="unfoldObj.foldTwo">
              <grid-manager
                v-if="newGoodsInfos.length"
                :option="gridOption1"
              ></grid-manager>
            </div>
          </section>
          <!-- 单据信息 -->
          <section
            v-if="showList.hasInvoicesInfo === 'Y'"
            id="tabcont2"
            class="invoice-card"
          >
            <div class="goods-top top-bottom row align-center space-between">
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.documentInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldThr')">
                <span v-if="unfoldObj.foldThr"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div
              class="row flex-wrap invoice-data"
              v-if="ordingData && unfoldObj.foldThr"
            >
              <div>
                {{$t('salesRecord.orderAmount')}}：<span class="red-text"
                  >{{ ordingData.totalPrice  }}đ</span
                >
              </div>
              <div>
                {{$t('salesRecord.retailAmount')}}：<span class="red-text"
                  >{{ ordingData.totalSellPrice }}đ</span
                >
              </div>
              <div>
                {{$t('salesRecord.receivedAmount')}}：<span class="red-text"
                  >{{ ordingData.receivedAmount }}đ</span
                >
              </div>
              <div v-if="ordingData.discountAmount">
                {{$t('salesRecord.activityAmount')}}：<span class="red-text"
                  >{{ ordingData.discountAmount }}đ</span
                >
              </div>
              <div v-if="ordingData.changePrice">
                {{$t('salesRecord.changeAmount')}}：<span class="red-text"
                  >{{ ordingData.changePrice }}đ</span
                >
              </div>
              <div>
                {{$t('salesRecord.salesStatus')}}：
                <span v-if="ordingData.state === '-1'">{{$t('salesRecord.cancelled')}}</span>
                <span v-if="ordingData.state === '1'">{{$t('salesRecord.pendingPayment')}}</span>
                <span v-if="ordingData.state === '2'">{{$t('salesRecord.paying')}}</span>
                <span v-if="ordingData.state === '3'">{{$t('salesRecord.paid')}}</span>
                <span v-if="ordingData.state === '4'">{{$t('salesRecord.pendingApproval')}}</span>
                <span v-if="ordingData.state === '5'">{{$t('salesRecord.invalidated')}}</span>
              </div>
              <div>
                {{$t('salesRecord.storeName')}}：<span>{{ ordingData.deptName }}</span>
              </div>
              <div v-if="ordingData.giftDetail">
                {{$t('salesRecord.giftInfo')}}：<span>{{ ordingData.giftDetail }}</span>
              </div>
              <div>
                {{$t('salesRecord.documentSource')}}：<span>{{
                  ordingData.source === "1" ? $t('salesRecord.mobile') : $t('salesRecord.client')
                }}</span>
              </div>
              <div>
                {{$t('salesRecord.orderNature')}}：<span>{{ ordingData.orderTypeTitle }}</span>
              </div>
              <div>
                {{$t('salesRecord.salesOrderNo')}}：<span>{{ ordingData.orderNo }}</span>
              </div>
              <div v-if="ordingData.originalInnerSn">
                {{$t('salesRecord.originalSalesOrderNo')}}：<span>{{ ordingData.originalInnerSn }}</span>
              </div>
              <div>
                {{$t('salesRecord.externalOrderNo')}}：<span>{{ ordingData.outerSn }}</span>
              </div>
              <div>
                {{$t('salesRecord.performanceMethod')}}：
                <span>{{
                  ordingData.brokerage === "1"
                    ? $t('salesRecord.personalPerformance')
                    : ordingData.brokerage === "2"
                    ? $t('salesRecord.teamPerformance')
                    : ordingData.brokerage === "3"
                    ? $t('salesRecord.distribution')
                    : ""
                }}</span>
              </div>
              <div
                v-if="
                  ordingData.brokerage === '1' && ordingData.shoppingGuideName
                "
              >
                {{$t('salesRecord.salesperson')}}：<span>{{ ordingData.shoppingGuideName }}</span>
              </div>
              <div>
                {{$t('salesRecord.creationTime')}}：<span>{{ ordingData.createTime }}</span>
              </div>
              <div
                v-if="
                  ordingData.brokerage === '2' && ordingData.shoppingGuideName
                "
                class="row"
                style="line-height: 20px; margin-top: 5px; width: 100%"
              >
                <span style="width: 77px; color: #999">{{$t('salesRecord.teamMembers')}}：</span>
                <span class="description">{{
                  ordingData.shoppingGuideName
                }}</span>
              </div>
              <div v-if="ordingData.createTerminalTitle">
                {{$t('salesRecord.createOrderCashier')}}：<span>{{
                  ordingData.createTerminalTitle
                }}</span>
              </div>
              <div v-if="ordingData.endTerminalTitle">
                {{$t('salesRecord.endOrderCashier')}}：<span>{{ ordingData.endTerminalTitle }}</span>
              </div>
            </div>
          </section>
          <!-- 促销信息 -->
          <section
            v-if="showList.hasPromotionInfo === 'Y'"
            id="tabcont3"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldFou ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.promotion')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldFou')">
                <span v-if="unfoldObj.foldFou"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-show="unfoldObj.foldFou">
              <el-table
                border
                :data="promotionInfo"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column prop="name" :label="$t('salesRecord.promotionName')"></el-table-column>
                <el-table-column prop="type" :label="$t('salesRecord.promotionType')"></el-table-column>
                <el-table-column prop="activityNo" :label="$t('salesRecord.promotionNo')"></el-table-column>
                <el-table-column prop="discountAmount" :label="$t('salesRecord.discountAmount')">
                  <template slot-scope="scope">
                    <div style="color: red">
                      {{ scope.row.discountAmount }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="paymentState" :label="$t('salesRecord.promotionDetails')">
                  <template slot-scope="scope">
                    <span
                      style="color: #0b83f3; cursor: pointer"
                      @click="showDetail(scope.row)"
                      >{{$t('salesRecord.viewDetails')}}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>
          <!-- 会员信息 -->
          <section
            v-if="showList.hasMemberInfo === 'Y'"
            id="tabcont4"
            class="invoice-card"
          >
            <div class="goods-top top-bottom row align-center space-between">
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.memberInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldFiv')">
                <span v-if="unfoldObj.foldFiv"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div
              v-if="vipData && unfoldObj.foldFiv"
              class="row flex-wrap invoice-data"
            >
              <div>
                {{$t('salesRecord.memberNickname')}}：<span>{{ vipData.nickname }}</span>
              </div>
              <div>
                {{$t('salesRecord.memberCardNo')}}：<span>{{ vipData.cardNumber }}</span>
              </div>
              <div>
                {{$t('salesRecord.totalConsumptionAmount')}}：<span>{{ vipData.totalSellAmount }}</span>
              </div>
              <div>
                {{$t('salesRecord.unitPrice')}}：<span>{{ vipData.unitPrice }}</span>
              </div>
              <div>
                {{$t('salesRecord.cardOpeningTime')}}：<span>{{ vipData.createTime }}</span>
              </div>
              <div>
                {{$t('salesRecord.totalConsumptionCount')}}：<span>{{ vipData.totalSellCount }}</span>
              </div>
              <div>
                {{$t('salesRecord.memberPoints')}}：<span>{{ vipData.integralBalance }}</span>
              </div>
              <div>
                {{$t('salesRecord.phoneNumber')}}：<span>{{ vipData.phone }}</span>
              </div>
              <div>
                {{$t('salesRecord.cardIssuingStore')}}：<span>{{ vipData.deptName }}</span>
              </div>
              <div>
                {{$t('salesRecord.averageConsumptionAmount')}}：<span>{{ vipData.avgSellAmount }}</span>
              </div>
              <div>
                {{$t('salesRecord.memberBalance')}}：<span>{{ vipData.accountBalance }}</span>
              </div>
            </div>
          </section>
          <!-- 收款信息 -->
          <section
            v-if="showList.hasPaymentInfo === 'Y' || thirdCouponInfos.length"
            id="tabcont5"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldSix ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.paymentInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldSix')">
                <span v-if="unfoldObj.foldSix"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-if="payList && payList.length > 0 && unfoldObj.foldSix">
              <el-table
                border
                :data="payList"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column
                  prop="paymentName"
                  :label="$t('salesRecord.paymentMethod')"
                ></el-table-column>
                <el-table-column
                  prop="paymentPrice"
                  :label="$t('salesRecord.paymentAmount')"
                ></el-table-column>
                <el-table-column prop="paymentState" :label="$t('salesRecord.paymentStatus')">
                  <template slot-scope="scope">
                    <el-tag
                      size="small"
                      effect="dark"
                      :type="
                        scope.row.paymentState == 0
                          ? 'primary'
                          : scope.row.paymentState == 1
                          ? 'success'
                          : scope.row.paymentState == 2
                          ? 'info'
                          : scope.row.paymentState == 3
                          ? 'danger'
                          : ''
                      "
                    >
                      {{
                        scope.row.paymentState == 0
                          ? $t('salesRecord.created')
                          : scope.row.paymentState == 1
                          ? $t('salesRecord.paid')
                          : scope.row.paymentState == 2
                          ? $t('salesRecord.cancelledPay')
                          : scope.row.paymentState == 3
                          ? $t('salesRecord.pendingPay')
                          : ""
                      }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  :label="$t('salesRecord.creationTime')"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="updateTime"
                  :label="$t('salesRecord.updateTime')"
                ></el-table-column>
                <el-table-column
                  prop="outerNo"
                  :label="$t('salesRecord.paymentVoucherNo')"
                ></el-table-column>
                <el-table-column
                  prop="serialNumber"
                  :label="$t('salesRecord.serialNumber')"
                ></el-table-column>
              </el-table>
            </div>

            <template v-if="thirdCouponInfos.length">
              <el-table
                border
                size="mini"
                style="margin-top: 10px;"
                :data="thirdCouponInfos"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }">
                <el-table-column prop="name" :label="$t('salesRecord.couponName')"></el-table-column>
                <el-table-column prop="couponTypeName" :label="$t('salesRecord.couponType')"></el-table-column>
                <el-table-column prop="channelName" :label="$t('salesRecord.couponSource')"></el-table-column>
                <el-table-column prop="actualDiscountAmount" :label="$t('salesRecord.couponDiscountAmount')">
                  <template slot-scope="scope">
                    <span style="color: #F8475F;">{{scope.row.actualDiscountAmount}}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('salesRecord.operation')">
                  <template slot-scope="scope">
                    <span style="color: #067cf2;cursor:pointer;" @click="showTicketInfo(scope.row)">{{$t('salesRecord.viewDetails')}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </section>
          <!-- 小票预览 -->
          <section v-if="1===2" id="tabcont6" class="invoice-card">
            <div class="goods-top top-bottom row align-center space-between">
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.receiptPreview')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldSev')">
                <span v-if="unfoldObj.foldSev"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div class="receipts-img" v-if="unfoldObj.foldSev">
              <webview
                v-if="webViewUrlPreview"
                class="webview"
                :src="webViewUrlPreview"
              ></webview>
            </div>
          </section>
          <!-- 审批信息 -->
          <section
            v-if="showList.hasReviewInfo === 'Y'"
            id="tabcont7"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldEit ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.approvalInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldEit')">
                <span v-if="unfoldObj.foldEit"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-show="unfoldObj.foldEit">
              <el-table
                border
                :data="reviewInfos"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column
                  prop="formSn"
                  :label="$t('salesRecord.approvalNo')"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="flowType"
                  :label="$t('salesRecord.processType')"
                  width="200"
                ></el-table-column>
                <el-table-column prop="state" :label="$t('salesRecord.status')">
                  <template slot-scope="scope">
                    <el-tag
                      size="mini"
                      effect="dark"
                      :type="
                        scope.row.state === '-2' || scope.row.state === '4'
                          ? 'info'
                          : scope.row.state === '2'
                          ? 'success'
                          : scope.row.state === '3'
                          ? 'danger'
                          : ''
                      "
                    >
                      {{
                        scope.row.state === "-2" || scope.row.state === "4"
                          ? $t('salesRecord.withdrawn')
                          : scope.row.state === "2"
                          ? $t('salesRecord.approved')
                          : scope.row.state === "3"
                          ? $t('salesRecord.rejected')
                          : $t('salesRecord.pendingReview')
                      }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="submitName"
                  :label="$t('salesRecord.initiator')"
                ></el-table-column>
                <el-table-column
                  prop="submitTime"
                  :label="$t('salesRecord.submissionTime')"
                ></el-table-column>
                <el-table-column
                  prop="lastUpdateTime"
                  :label="$t('salesRecord.updateTime')"
                ></el-table-column>
                <el-table-column
                  prop="userName"
                  :label="$t('salesRecord.approver')"
                ></el-table-column>
                <el-table-column
                  prop="refuseDesc"
                  :label="$t('salesRecord.rejectionReason')"
                  width="130"
                ></el-table-column>
                <el-table-column
                  prop="paymentState"
                  :label="$t('salesRecord.approvalDetails')"
                  width="150"
                >
                  <template slot-scope="operation">
                    <el-button
                      type="text"
                      @click="
                        () => {
                          reviewInfo = operation.row;
                          AuditDetailsModal = true;
                        }
                      "
                    >
                      {{$t('salesRecord.viewDetails')}}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>
          <!-- 售后信息 -->
          <section
            v-if="showList.hasAftersalesInfo === 'Y'"
            id="tabcont8"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldNan ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.afterSalesInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldNan')">
                <span v-if="unfoldObj.foldNan"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-show="unfoldObj.foldNan">
              <el-table
                border
                :data="aftersalesInfo"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column
                  prop="salesTypeName"
                  :label="$t('salesRecord.afterSalesType')"
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="afterInnerSn"
                  :label="$t('salesRecord.afterSalesOrderNo')"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  :label="$t('salesRecord.afterSalesTime')"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="realPrice"
                  :label="$t('salesRecord.goodsAmount')"
                  width="120"
                ></el-table-column>
                <el-table-column prop="realPrice" :label="$t('salesRecord.status')" width="150">
                  <template slot-scope="scope">
                    <el-tag
                      effect="dark"
                      type="primary"
                      v-if="scope.row.effectState === '0'"
                      >{{$t('salesRecord.pendingEffect')}}</el-tag
                    >
                    <el-tag
                      effect="dark"
                      type="success"
                      v-if="scope.row.effectState === '1'"
                      >{{$t('salesRecord.effective')}}</el-tag
                    >
                    <el-tag
                      effect="dark"
                      type="danger"
                      v-if="scope.row.effectState === '2'"
                      >{{$t('salesRecord.invalid')}}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('salesRecord.remarks')"></el-table-column>
              </el-table>
            </div>
          </section>
          <!-- 物流信息 -->
          <section
            v-if="showList.logisticsInfo === 'Y'"
            id="tabcont9"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldTwe ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.logisticsInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldTwe')">
                <span v-if="unfoldObj.foldTwe"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-show="unfoldObj.foldTwe">
              <el-table
                border
                :data="logisticsInfo"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column
                  prop="recipientName"
                  :label="$t('salesRecord.recipient')"
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="recipientPhone"
                  :label="$t('salesRecord.recipientPhone')"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="recipientAddress"
                  :label="$t('salesRecord.receivingAddress')"
                ></el-table-column>
                <el-table-column prop="orderType" :label="$t('salesRecord.orderMethod')">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.orderType === "1"
                        ? $t('salesRecord.jdAutoOrder')
                        : scope.row.orderType === "2"
                        ? $t('salesRecord.manualOrder')
                        : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="state" :label="$t('salesRecord.logisticsStatus')" align="center">
                  <template slot-scope="scope">
                    <el-tag
                      effect="dark"
                      :type="
                        scope.row.state == -1
                          ? 'warning'
                          : scope.row.state == 0
                          ? 'primary'
                          : scope.row.state == 2
                          ? 'success'
                          : 'primary'
                      "
                    >
                      {{
                        scope.row.state == -1
                          ? $t('salesRecord.cancelledPay')
                          : scope.row.state == 0
                          ? $t('salesRecord.packaged')
                          : scope.row.state == 2
                          ? $t('salesRecord.signed')
                          : $t('salesRecord.shipped')
                      }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="logisticsName"
                  :label="$t('salesRecord.courierCompany')"
                ></el-table-column>
                <el-table-column
                  prop="expressNo"
                  :label="$t('salesRecord.trackingNumber')"
                ></el-table-column>
                <el-table-column :label="$t('salesRecord.operation')" width="180">
                  <template slot-scope="scope">
                    <div style="color: #0B83F3;cursor:pointer;"
                      v-if="scope.row.type.toString() === '1'"
                      @click="cancelLogistics(scope.row)"
                      >{{$t('salesRecord.cancel')}}</div
                    >
                    <div style="color: #0B83F3;cursor:pointer;"
                      v-if="scope.row.orderType === '2'"
                      @click="sendExpressage(scope.row)"
                      >{{$t('salesRecord.modify')}}</div
                    >
                    <div style="color: #0B83F3;cursor:pointer;"
                      @click="showTrack(scope.row)"
                      >{{$t('salesRecord.logisticsTracking')}}</div
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>
          <!-- 客订信息 -->
          <section
            v-if="showList.hasBookingInfo === 'Y'"
            id="tabcont10"
            class="invoice-card"
          >
            <div
              class="goods-top row align-center space-between"
              :class="[!unfoldObj.foldThir ? 'top-bottom' : '']"
            >
              <div class="row align-center">
                <span class="title-label"></span>
                <span class="title-text">{{$t('salesRecord.customOrderInfo')}}</span>
              </div>
              <div class="show-hidden" @click="unfoldHandel('foldThir')">
                <span v-if="unfoldObj.foldThir"
                  >{{$t('salesRecord.collapse')}}<i class="el-icon-arrow-up"></i
                ></span>
                <span v-else>{{$t('salesRecord.expand')}}<i class="el-icon-arrow-down"></i></span>
              </div>
            </div>
            <div v-show="unfoldObj.foldThir">
              <el-table
                border
                :data="bookingApplyList"
                :header-cell-style="{ background: '#FAFAFA', color: '#436481' }"
                :cell-style="{ padding: '10px 0' }"
              >
                <el-table-column
                  prop="guestBookingOrderNo"
                  :label="$t('salesRecord.customOrderNo')"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="applyType"
                  :label="$t('salesRecord.customOrderType')"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="stateDesc"
                  :label="$t('salesRecord.status')"
                ></el-table-column>
                <el-table-column
                  prop="unitName"
                  :label="$t('salesRecord.deliveryStore')"
                ></el-table-column>
                <el-table-column prop="paymentState" :label="$t('salesRecord.operation')" width="150">
                  <template slot-scope="operation">
                    <el-button
                      type="text"
                      v-if="
                        operation.row.state == '0' || operation.row.state == '1'
                      "
                      @click="closeSuited(operation.row)"
                    >
                      {{$t('salesRecord.close')}}
                    </el-button>
                    <el-button
                      type="text"
                      style="color: red"
                      @click="outOfStockOrderDatil(operation.row)"
                    >
                      {{$t('salesRecord.viewDetails')}}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>
        </section>
        <section class="bot-fixed row align-center" style="padding-left: 20px">
          <div
            v-if="handeBtnList.includes('3')"
            class="tools-btn"
            @click="btnClick('3')"
            style="background: #9079c1;">
            {{$t('salesRecord.printReceipt')}}
          </div>
          <div
            v-if="handeBtnList.indexOf('4') !== -1"
            class="tools-btn"
            @click="btnClick('4')"
            style="background: #dd8595"
          >
            {{$t('salesRecord.continuePayment')}}
          </div>
          <div
            v-if="handeBtnList.indexOf('7') !== -1"
            class="tools-btn"
            @click="btnClick('7')"
            style="background: #43435c"
          >
            {{$t('salesRecord.cancelOrder')}}
          </div>
          <div
            v-if="btnAction.isRetreat === 'Y'"
            class="tools-btn"
            style="background: #f00"
            @click="exchangeHandel('1')"
          >
            {{$t('salesRecord.returnRefund')}}
          </div>
          <div
            v-if="btnAction.isAllRetreat === 'Y'"
            class="tools-btn"
            style="background: #f00"
            @click="exchangeHandel('4')"
          >
            {{$t('salesRecord.fullRefund')}}
          </div>
          <div
            v-if="ordingData && ordingData.state == '6'"
            class="tools-btn"
            style="background: #f00"
            @click="exchangeHandel('return')"
          >
            {{$t('salesRecord.confirmReturn')}}
          </div>
          <div
            v-if="ordingData && ordingData.state == '6'"
            class="tools-btn"
            style="background: #43435c"
            @click="exchangeHandel('noReturn')"
          >
            {{$t('salesRecord.cancelReturn')}}
          </div>
          <div
            v-if="
              handeBtnList.indexOf('17') !== -1 &&
              showList.afterSalesType === '0'
            "
            class="tools-btn"
            @click="sendExpressage()"
          >
            {{$t('salesRecord.sendToCustomer')}}
          </div>
<!--          <div-->
<!--            v-if="btnAction.isLackGoodsBooking == 'Y'"-->
<!--            class="tools-btn"-->
<!--            @click="outOfStockOrder()"-->
<!--          >-->
<!--            {{$t('salesRecord.outOfStockOrder')}}-->
<!--          </div>-->
        </section>
      </section>
      <section class="section-main" style="background: #fff" v-else>
        <noDataState :textDesc="$t('salesRecord.noOrderData')" marginTop="280"></noDataState>
      </section>
    </section>
    <DoReceipts
      v-if="DoReceiptsModal"
      :title="$t('print.printTitle')"
      :webViewUrl="webViewUrl"
      @close="DoReceiptsModal = false"
    ></DoReceipts>
    <PromotionDetails
      v-if="promotionModal"
      :promotionObj="promotionObj"
      @close="promotionModal = false"
    >
    </PromotionDetails>
    <PayDialog
      v-if="payTypeDialog"
      :vipData="vipData"
      :orderMoney="orderMoney"
      :againPay="againPay"
      @close="closePayModule"
    ></PayDialog>
    <CancelOrder
      v-if="CancelOrderModal"
      :ordingId="ordingId"
      :thirdCouponInfos="thirdCouponInfos"
      :receivedAmount="ordingData.receivedAmount"
      @close="cancelClose"
    ></CancelOrder>
    <AuditDetails
      v-if="AuditDetailsModal"
      :reviewInfo="reviewInfo"
      @close="AuditDetailsModal = false"
    ></AuditDetails>
    <ReturnGoods
      v-if="returnVisible"
      :invoicesItem="invoicesItem"
      @close="returnVisible = false"
      @refresh="refreshHandel(1)"
    ></ReturnGoods>
    <outOfStockOrder
      v-if="outOfStockVisible"
      :invoicesItem="invoicesItem"
      @close="outOfStockVisible = false"
      @refresh="refreshHandel(4)"
    ></outOfStockOrder>
    <ExchangeGoods
      v-if="exchangeVisible"
      :invoicesItem="invoicesItem"
      @close="exchangeVisible = false"
      @refresh="refreshHandel(2)"
    ></ExchangeGoods>
    <AllOrdingReturn
      v-if="allReturnVisible"
      :invoicesItem="invoicesItem"
      @close="allReturnVisible = false"
      @refresh="refreshHandel(3)"
    ></AllOrdingReturn>
    <SendGoods
      v-if="sendVisible"
      :snData="snData"
      @close="sendVisible = false"
      @refresh="queryInvoices"
    ></SendGoods>
    <TrackDialog
      v-if="showTrackDialog"
      :expressNo="trackData"
      @close="showTrackDialog = false"
    ></TrackDialog>
    <TicketDetail v-if="ticketDrawer" :dataInfo="ticketData" @close="ticketDrawer = false"></TicketDetail>
  </section>
</template>

<script>
import { ipcApiRoute, specialIpcRoute } from "@/api/main";
import { ipc } from "@/utils/ipcRenderer";
import stockTopMenu from "../../components/stockTopMenu.vue";
import tabsMenu from "../../components/tabsMenu.vue";
import ExchangeGoods from "./components/ExchangeGoods.vue";
import ReturnGoods from "./components/ReturnGoods.vue";
import asideContent from "./components/asideContent.vue";
import noDataState from "@/components/noDataState.vue";
import DoReceipts from "./components/DoReceipts.vue";
import PromotionDetails from "./components/PromotionDetails.vue";
import AuditDetails from "./components/AuditDetails.vue";
import CancelOrder from "./components/CancelOrder.vue";
import AllOrdingReturn from "./components/AllOrdingReturn";
import SendGoods from "./components/SendGoods";
import TrackDialog from "@/views/expressDelivery/components/trackDialog";
import PayDialog from "@/components/PayDialog.vue";
import request from "@/libs/http/index";
import outOfStockOrder from "./components/outOfStockOrder.vue";
import TicketDetail from "./components/TicketDetail.vue";
import { erpPackageRecallJdExpress } from "@/libs/http/api";
import {
  visitorCancelApplay,
  queryBookingApplyPojo,
} from "@/libs/http/modules/customer";
import {
  queryInvoicesInfo,
  generatePayInfo,
  takeOutPendingList,
  cancelOrdingState,
  queryInvoiceNewInfo,
  confirmedReturnOrder, posOrderPayInfo,
} from "@/libs/http/modules/posOrder";
export default {
  components: {
    stockTopMenu,
    tabsMenu,
    asideContent,
    ExchangeGoods,
    ReturnGoods,
    noDataState,
    DoReceipts,
    PromotionDetails,
    PayDialog,
    AuditDetails,
    CancelOrder,
    SendGoods,
    TrackDialog,
    AllOrdingReturn,
    outOfStockOrder,
    TicketDetail
  },
  data() {
    return {
      hasReceiptInfo: "",
      infoDetailLoading: false,
      curTab: "",
      tabList: [],
      domArray: [],
      DoReceiptsModal: false,
      promotionModal: false,
      AuditDetailsModal: false,
      ordingId: "",
      invoicesNo: "",
      ordingData: null,
      vipData: null,
      payList: [],
      goodsTable: [],
      promotionInfo: [],
      thirdCouponInfos: [],
      sell: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/sell.png") : require("@/assets/images/vnSell.png"),
      give: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/give.png") : require("@/assets/images/vnGave.png"),
      back: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/return.png") : require("@/assets/images/vnReturn.png"),
      rite: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/rite.png") : require("@/assets/images/vnGift.png"),
      ned: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/ned.png") : require("@/assets/images/vnChange.png"),
      gridOption: {
        gridManagerName: "old-goods-list",
        firstLoading: true,
        height: "auto",
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: "goodsNature",
            text: this.$t('gridManage.columnType'),
            align: "center",
            width: "70px",
            template: () => {
              return `
								<div>
								  <img style="width:40px;height:40px;" v-if="row.goodsNature === '1'" :src="sell" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '2'" :src="give" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '4'" :src="back" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '3'" :src="rite" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '6'" :src="ned" />
								</div>
							`;
            },
          },
          {
            key: "goodsName",
            text: this.$t('gridManage.columnGoodsInfo'),
            align: "center",
            width: "350px",
            template: () => {
              return `
								<div class="row align-center" style="text-align:left;">
									<div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
										<el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
										<div class="row align-center space-center" v-else style="width:102px;height:92px;border-radius:4px;text-align:center;color:#999;background:#f5f5f5;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
										<div v-if="row.promoteActivityId || row.goodsNature === '2' || row.isAdd === 1 || row.dataType === 'other' || [0, 3].includes(row.couponType)"
											style="width:70px;height:18px;line-height:18px;position:absolute;top:10px;right:-16px;transform: rotate(45deg);text-align:center;color:#fff;font-size: 8px;"
											:style="row.isAdd === 1 ? 'background: linear-gradient(0deg, rgb(116,47,169), rgb(101,41,147), rgb(72,30,105))' : row.goodsNature === '2' ? 'background: linear-gradient(0deg, #208AEC, #02D7F0, #00C6F7)' : 'background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400)'">
											<span>{{row.isAdd === 1 ? $t('gridManage.addBuy') : row.goodsNature === '2' ? $t('gridManage.gave') : row.promoteActivityId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}</span>
										</div>
									</div>
									<div v-if="row.dataType === 'other'" style="margin-left:10px;flex:1;height: 90px;">
									  <div>{{row.couponTypeName}}</div>
                    <div style="width: 150px;white-space: pre-wrap;">{{row.name}}</div>
                  </div>
									<div v-else class="column space-between" style="margin-left:10px;flex:1;height: 90px;">
                    <div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
									</div>
								</div>
							`;
            },
          },
          {
            key: "colorDesc",
            text: this.$t('gridManage.columnAttr'),
            align: "center",
            width: "130px",
            template: () => {
              return `
								<div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
									<p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
										<span v-if="index == 0" style="margin:0 3px;">,</span>
									</p>
								</div>
                			`;
            },
          },
          {
            key: "number",
            text: this.$t('gridManage.number'),
            align: "center",
            width: "100px",
            template: () => {
              return `
								<div style="font-size:20px;">
									{{row.number}}
								</div>
                			`;
            },
          },
          {
            key: "tagPrice",
            text: this.$t('gridManage.tagPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center">
									<span style="font-size:20px;">{{row.tagPrice}}đ</span>
								</div>
                			`;
            },
          },
          {
            key: "sellPrice",
            text: this.$t('gridManage.retailPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center">
									<span style="font-size:20px;">{{row.sellPrice}}đ</span>
								</div>
            				`;
            },
          },
          {
            key: "unitRealPrice",
            text: this.$t('gridManage.realPriceUnit'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center">
									<span v-if="row.dataType !== 'other'" style="color:#666;font-size:20px;">{{row.unitRealPrice}}đ</span>
								</div>
                			`;
            },
          },
          {
            key: "totalRealPrice",
            text: this.$t('gridManage.totalPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
									{{row.totalRealPrice}}đ
								</div>
                			`;
            },
          },
        ],
        ajaxData: this.showGoodsTable,
      },
      gridOption1: {
        gridManagerName: "new-goods-list",
        firstLoading: true,
        height: "auto",
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: "goodsNature",
            text: this.$t('gridManage.columnType'),
            align: "center",
            width: "70px",
            template: () => {
              return `
								<div>
								  <img style="width:40px;height:40px;" v-if="row.goodsNature === '1'" :src="sell" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '2'" :src="give" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '4'" :src="back" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '3'" :src="rite" />
                  <img style="width:40px;height:40px;" v-if="row.goodsNature === '6'" :src="ned" />
								</div>
							`;
            },
          },
          {
            key: "goodsName",
            text: this.$t('gridManage.columnGoodsInfo'),
            align: "center",
            width: "350px",
            template: () => {
              return `
								<div class="row align-center" style="text-align:left;">
									<div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
										<el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
										<div class="row align-center space-center" v-else style="width:102px;height:92px;border-radius:4px;text-align:center;color:#999;background:#f5f5f5;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
										<div v-if="row.promoteActivityId || row.goodsNature === '2' || row.isAdd === 1 || row.dataType === 'other' || [0, 3].includes(row.couponType)"
											style="width:70px;height:18px;line-height:18px;position:absolute;top:10px;right:-16px;transform: rotate(45deg);text-align:center;color:#fff;font-size: 8px;"
											:style="row.isAdd === 1 ? 'background: linear-gradient(0deg, rgb(116,47,169), rgb(101,41,147), rgb(72,30,105))' : row.goodsNature === '2' ? 'background: linear-gradient(0deg, #208AEC, #02D7F0, #00C6F7)' : 'background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400)'">
											<span>{{row.isAdd === 1 ? $t('gridManage.addBuy') : row.goodsNature === '2' ? $t('gridManage.gave') : row.promoteActivityId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}</span>
										</div>
									</div>
									<div v-if="row.dataType === 'other'" style="margin-left:10px;flex:1;height: 90px;">
									  <div>{{row.couponTypeName}}</div>
                    <div style="width: 150px;white-space: pre-wrap;">{{row.name}}</div>
                  </div>
									<div v-else class="column space-between" style="margin-left:10px;flex:1;height: 90px;">
                    <div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
									</div>
								</div>
							`;
            },
          },
          {
            key: "colorDesc",
            text: this.$t('gridManage.columnAttr'),
            align: "center",
            width: "130px",
            template: () => {
              return `
								<div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
									<p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
										<span v-if="index == 0" style="margin:0 3px;">,</span>
									</p>
								</div>
                			`;
            },
          },
          {
            key: "number",
            text: this.$t('gridManage.number'),
            align: "center",
            width: "100px",
            template: () => {
              return `
								<div style="font-size:20px;">
									{{row.number}}
								</div>
                			`;
            },
          },
          {
            key: "tagPrice",
            text: this.$t('gridManage.tagPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center">
									<span style="font-size:20px;">{{row.tagPrice}}đ</span>
								</div>
                			`;
            },
          },
          {
            key: "sellPrice",
            text: this.$t('gridManage.retailPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center">
									<span style="font-size:20px;">{{row.sellPrice}}đ</span>
								</div>
            				`;
            },
          },
          {
            key: "unitRealPrice",
            text: this.$t('gridManage.realPriceUnit'),
            align: "center",
            template: () => {
              return `
								<div v-if="row.dataType !== 'other'" class="row align-center space-center">
									<span style="color:#666;font-size:20px;">{{row.unitRealPrice}}đ</span>
								</div>
                			`;
            },
          },
          {
            key: "totalRealPrice",
            text: this.$t('gridManage.totalPrice'),
            align: "center",
            template: () => {
              return `
								<div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
									{{row.totalRealPrice}}đ
								</div>
                			`;
            },
          },
        ],
        ajaxData: this.showGoodsTables,
      },
      handeBtnList: [],
      showList: null,
      scrollFlag: true,
      aftersalesInfo: [],
      payTypeDialog: false,
      totalPrice: "",
      againPay: null,
      orderMoney: null,
      promotionObj: null,
      reviewInfos: [],
      reviewInfo: null,
      hasReviewing: "N",
      CancelOrderModal: false,
      newGoodsInfos: [],
      bookingApplyList: [],
      currentCount: 0,
      initCount: 0,
      unfoldObj: {
        foldOne: true,
        foldTwo: true,
        foldThr: true,
        foldFou: true,
        foldFiv: true,
        foldSix: true,
        foldSev: true,
        foldEit: true,
        foldNan: true,
        foldTen: true,
        foldEve: true,
        foldTwe: true,
        foldThir: true,
      },
      webViewUrl: "",
      webViewUrlPreview: "",
      returnVisible: false,
      exchangeVisible: false,
      invoicesItem: null,
      btnAction: {},
      allReturnVisible: false,
      crmAmount: "",
      otherAmount: "",
      couponAmount: "",
      showTrackDialog: false,
      trackData: {},
      logisticsInfo: [],
      sendVisible: false,
      outOfStockVisible: false,
      snData: null,
      ticketData: null,
      ticketDrawer: false
    };
  },
  created() {
    document.title = this.$t('salesRecord.salesRecord')
    this.$nextTick(() => {
      this.$refs.ording.queryHangList();
    });
  },
  mounted() {
    ipc.on(specialIpcRoute.window1ToWindow2, (event, arg) => {
      this.$refs.ording.queryHangList();
    });
  },
  methods: {
    closeSuited(row) {
      this.$confirm(this.$t('salesRecord.confirmClose'), this.$t('salesRecord.tips'))
        .then(() => {
          visitorCancelApplay({
            appId: row.id,
          })
            .then((data) => {
              this.queryInvoices();
              this.$message({
                type: "success",
                message: this.$t('salesRecord.operationSuccess'),
                duration: 2000,
                showClose: true,
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
                duration: 2000,
                showClose: true,
              });
            });
        })
        .catch((err) => {});
    },
    outOfStockOrder() {
      this.invoicesItem = {
        id: this.ordingData.id,
        orderTypeId: this.ordingData.orderTypeCode || "1",
        orderNo: this.ordingData.orderNo,
      };
      this.outOfStockVisible = true;
    },
    async outOfStockOrderDatil(row) {
      let options = {
        type: "vue",
        content: "/customerOrder",
        windowName: this.$t('deptCollectMoney.customOrder'),
        winId: "customerOrder",
        params: row.guestBookingOrderNo,
      };
      ipc.invoke(ipcApiRoute.createWindow, options).then((r) => {});
      const newWcId = await ipc.invoke(ipcApiRoute.getWCid, options.windowName);
      if (newWcId) {
        ipc.sendTo(newWcId, specialIpcRoute.window1ToWindow2, options);
      }
    },
    cancelClose(e) {
      this.CancelOrderModal = false;
      if (e === "refresh") {
        this.queryInvoices();
      }
    },
    btnClick(index) {
      if (this.hasReviewing === "Y") {
        this.$message({
          showClose: true,
          message: this.$t('salesRecord.hasReviewingNotOperate'),
          type: "error",
          duration: 2000,
        });
      } else {
        if (index === "3") {
          this.queryPrintData("N");
        }
        if (index === "4") {
          if (this.$amount.lessThanOrEquals(this.ordingData.totalPrice, 0)) {
            this.payLose();
          } else {
            this.againPay = {
              againPayId: this.ordingId,
              againinvoicesNo: this.invoicesNo
            };
            this.orderMoney = {
              totalPrice: this.ordingData.totalPrice,
              receivedAmount: this.ordingData.receivedAmount,
            };
            if (this.ordingData.receivedAmount) {
              this.orderMoney.receivablePrice = (
                this.ordingData.totalPrice - this.ordingData.receivedAmount
              ).toFixed(2);
            }
            this.payTypeDialog = true;
          }
        }
        if (index === "7") {
          this.CancelOrderModal = true;
        }
        if (index === "16") {
          this.editorGoods("16");
        }
      }
    },
    editorGoods() {
      const cashierItem = JSON.parse(this.$cache.local.get("cashierDeskItem"));
      this.$confirm(this.$t('salesRecord.confirmModifyOrder'), this.$t('salesRecord.tips'))
        .then(() => {
          takeOutPendingList({
            terminalId: cashierItem ? cashierItem.id : "",
            id: this.ordingId,
            isUpdate: "Y",
          })
            .then(async (data) => {
              this.cancelHandel();
              let options = {
                type: "vue",
                content: "/deptCollectMoney",
                windowName: this.$t('salesRecord.openCollectMoney'),
                winId: "deptCollectMoney",
                params: {
                  winId: "deptCollectMoney",
                },
              };
              ipc.invoke(ipcApiRoute.createWindow, options).then((r) => {});
              const newWcId = await ipc.invoke(
                ipcApiRoute.getWCid,
                options.windowName
              );
              if (newWcId) {
                ipc.sendTo(newWcId, specialIpcRoute.window1ToWindow2, data);
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
                duration: 2000,
                showClose: true,
              });
            });
        })
        .catch(() => {});
    },
    showDetail(row) {
      row.orderId = this.ordingId;
      this.promotionObj = row;
      this.promotionModal = true;
    },
    cancelHandel() {
      const cashierItem = JSON.parse(this.$cache.local.get("cashierDeskItem"));
      cancelOrdingState({
        orderId: this.ordingId,
        terminalId: cashierItem ? cashierItem.id : "",
      })
        .then((data) => {
          this.queryInvoices();
        })
        .catch((err) => {});
    },
    payLose() {
      const cashierItem = JSON.parse(this.$cache.local.get("cashierDeskItem"));
      generatePayInfo({
        id: this.ordingData.id,
        isAlteration: "Y",
        proceedsInfoList: [
          { id: "1", proceedsPrice: this.ordingData.totalPrice },
        ],
        terminalId: cashierItem ? cashierItem.id : "",
      })
        .then((data) => {
          this.queryInvoices("", "Y");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
            duration: 2000,
            showClose: true,
          });
        });
    },
    queryPrintData(type) {
      let printer = this.$cache.local.get("printerModel");
      let printCode = this.$cache.local.get("retailReceiptCode");
      let params = {
        sn: this.ordingData.orderNo,
      };
      if (type === "Y") {
        this.webViewUrlPreview = `${
          request.printPreviewRoot
        }?printerName=${printer}&templateCode=${printCode}&printCount=0&data=${encodeURI(
          JSON.stringify(params)
        )}`;
      } else {
        this.DoReceiptsModal = true;
        let printCount = this.$cache.local.get("retailReceiptCount");
        this.webViewUrl = `${
          request.printPreviewRoot
        }?printerName=${printer}&templateCode=${printCode}&printCount=0&data=${encodeURI(
          JSON.stringify(params)
        )}`;
        let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${printer}&templateCode=${printCode}&`;
        const eggSrc =
          eggRootUrl +
          `printCount=${printCount}&data=${encodeURI(
            JSON.stringify(params)
          )}&sn=${params["sn"]}`;
        ipc
          .invoke(ipcApiRoute.print, { contentUrl: eggSrc, sn: params["sn"] })
          .then((r) => {});
      }
    },
    scrollChange(e) {
      if (!this.scrollFlag) {
        return (this.scrollFlag = true);
      }
      let arr = this.domArray;
      let idx;
      arr.forEach((ele) => {
        if (e.target.scrollTop > ele.top) {
          idx = ele.id + "";
        }
      });
      this.curTab = idx;
    },
    getCurTab(e) {
      this.scrollFlag = false;
      this.curTab = e.id;
      let scrollHight = document.querySelector("#goods-scroll");
      if (e.index === 0) {
        return (scrollHight.scrollTop = 0);
      }
      scrollHight.scrollTop = this.domArray[e.index]?.top;
    },
    getCurOrdingObj(e) {
      this.tabList = [];
      this.domArray = [];
      if (e && e.id && e.invoicesNo) {
        this.ordingId = e.id;
        this.invoicesNo = e.invoicesNo;
        this.showList = e.item;
        this.queryInvoices(e.first, e.item.hasReceiptInfo);
      } else {
        this.ordingId = "";
        this.invoicesNo = "";
        return;
      }
      let pushData = {
        hasSkuInfo: { name: this.$t('salesRecord.goodsInfo'), id: "0" },
        hasInvoicesInfo: { name: this.$t('salesRecord.documentInfo'), id: "2" },
        hasPromotionInfo: { name: this.$t('salesRecord.promotionInfo'), id: "3" },
        hasMemberInfo: { name: this.$t('salesRecord.memberInfo'), id: "4" },
        hasPaymentInfo: { name: this.$t('salesRecord.paymentInfo'), id: "5" },
        // hasReceiptInfo: { name: this.$t('salesRecord.receiptPreview'), id: "6" },
        hasReviewInfo: { name: this.$t('salesRecord.approvalInfo'), id: "7" },
        hasAftersalesInfo: { name: this.$t('salesRecord.afterSalesInfo'), id: "8" },
        logisticsInfo: { name: this.$t('salesRecord.logisticsInfo'), id: "9" },
        hasBookingInfo: { name: this.$t('salesRecord.customOrderInfo'), id: "10" }
      };
      Object.keys(pushData).forEach((key) => {
        if (Object.keys(e.item).includes(key) && e.item[key] === "Y") {
          this.tabList.push(pushData[key]);
        }
      });
    },
    async queryInvoices(fir, isminp) {
      let res = await posOrderPayInfo({id: this.ordingId})
      this.newFetchInfo();
      this.handeBtnList = [];
      this.infoDetailLoading = true;
      queryInvoicesInfo({
        orderId: this.ordingId
      })
        .then((data) => {
          let scrollHight = document.querySelector("#goods-scroll");
          scrollHight.scrollTop = 0;
          this.curTab = "0";
          this.hasReceiptInfo = data.hasReceiptInfo;
          if (data.storeInfo || data.couponInfoList) {
            let otherList = []
            if(data.couponInfoList && data.couponInfoList[0]){
              this.thirdCouponInfos = data.couponInfoList
            }else{
              this.thirdCouponInfos = []
            }
            this.thirdCouponInfos.forEach(item=>{
              if([1, 2].includes(item.couponType)){
                let obj = {
                  ...item,
                  dataType: 'other',
                  goodsNature: this.showList.afterSalesType !== '0' ? '4' : '1'
                }
                otherList.push(obj)
              }
            })
            this.goodsTable = [...data.storeInfo, ...otherList];
            if (!fir) {
              GridManager.refreshGrid(this.gridOption.gridManagerName);
            }
          }
          if (data.orderInfo) {
            this.ordingData = data.orderInfo;
            this.totalPrice = this.ordingData.totalRealPrice;
            if (
              this.showList.state !== this.ordingData.state ||
              this.showList.realAmount !== this.ordingData.receivedAmount
            ) {
              this.$refs.ording.changeState(
                this.ordingData.state,
                this.ordingData.receivedAmount
              );
            }
          }
          if (data.memberInfo) {
            this.vipData = data.memberInfo;
          } else {
            this.vipData = null;
          }
          if (data.paymentInfo) {
            this.payList = data.paymentInfo;
            this.showList.hasPaymentInfo = "Y";
            let index = this.tabList.findIndex((item) => {
              return item.id === "5";
            });
            if (index === -1) {
              this.tabList.push({
                id: "5",
                name: this.$t('salesRecord.paymentInfo'),
              });
            }
            // if (isminp === "Y") {
            //   this.queryPrintData("Y");
            //   this.showList.hasReceiptInfo = "Y";
            //   let idx = this.tabList.findIndex((item) => {
            //     return item.id === "6";
            //   });
            //   if (idx === -1) {
            //     this.tabList.push({
            //       id: "6",
            //       name: this.$t('salesRecord.receiptPreview'),
            //     });
            //   }
            // }
          } else {
            this.payList = [];
            this.webViewUrl = null;
            this.webViewUrlPreview = null;
          }
          if (this.hasReceiptInfo === "N") {
            let index = this.tabList.findIndex((item) => {
              return item.name === this.$t('salesRecord.receiptPreview');
            });
            if (index !== -1) {
              this.tabList.splice(index, 1);
            }
          }
          if (data.promotionInfo) {
            this.promotionInfo = data.promotionInfo || [];
          } else {
            this.promotionInfo = [];
          }
          if (data.reviewInfos && data.reviewInfos[0]) {
            this.reviewInfos = data.reviewInfos;
            this.showList.hasReviewInfo = "Y";
            let index = this.tabList.findIndex((item) => {
              return item.id === "7";
            });
            if (index === -1) {
              this.tabList.push({
                name: this.$t('salesRecord.approvalInfo'),
                id: "7",
              });
            }
          }
          if (data.hasReviewing) {
            this.hasReviewing = data.hasReviewing;
          }

          if (data.logisticsInfo && data.logisticsInfo.length) {
            this.logisticsInfo = data.logisticsInfo;
            this.showList.logisticsInfo = "Y";
            let index = this.tabList.findIndex((item) => {
              return item.id === "9";
            });
            if (index === -1) {
              this.tabList.push({
                name: this.$t('salesRecord.logisticsInfo'),
                id: "9",
              });
            }
          } else {
            this.logisticsInfo = [];
          }
          this.$nextTick(() => {
            this.tabList.forEach((item, index) => {
              this.domArray.push({
                label: item.name,
                id: item.id,
              });
            });
            this.domArray.map((item) => {
              let dom = document.querySelector(`#tabcont${item.id}`);
              if (dom) {
                item.top = dom.offsetTop;
              }
            });
          });
          if (data.operationStates && data.operationStates.length) {
            this.handeBtnList = data.operationStates;
          }
          setTimeout(() => {
            this.infoDetailLoading = false;
          }, 500);
          for (let key in this.unfoldObj) {
            this.unfoldObj[key] = true;
          }
        })
        .catch((err) => {
          this.infoDetailLoading = false;
          this.$message({
            showClose: true,
            message: err,
            type: "error",
            duration: 2000,
          });
        });
    },
    showGoodsTable() {
      if (this.goodsTable.length) {
        this.initCount = this.goodsTable.reduce((prev, cur) => {
          return prev + Number(cur.number);
        }, 0);
        return new Promise((resolve, reject) => {
          const tableData = {
            // data: [...this.goodsTable, ...otherList],
            data: this.goodsTable
          };
          resolve(tableData);
        });
      }
    },
    showGoodsTables() {
      if (this.newGoodsInfos.length) {
        this.currentCount = this.newGoodsInfos.reduce((prev, cur) => {
          return prev + Number(cur.number);
        }, 0);
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.newGoodsInfos,
          };
          resolve(tableData);
        });
      }
    },
    closePayModule(refresh) {
      this.payTypeDialog = false;
      if (refresh) {
        this.queryInvoices("", "Y");
      }
    },
    unfoldHandel(nat) {
      this.unfoldObj[nat] = !this.unfoldObj[nat];
    },
    newFetchInfo() {
      this.btnAction = {};
      this.newGoodsInfos = [];
      this.aftersalesInfo = [];
      this.showList.hasAftersalesInfo = "N";
      if (
        this.showList.afterSalesType !== "0" ||
        this.showList.isDefectiveSalary === "Y"
      )
        return;
      queryInvoiceNewInfo({
        id: this.ordingId,
      })
        .then((res) => {
          this.crmAmount = res.crmAmount;
          this.otherAmount = res.otherAmount;
          this.couponAmount = res.couponAmount
          this.btnAction = {
            isRetreat: res.isRetreat,
            isAllRetreat: res.isAllRetreat,
            isActivityChange: res.isActivityChange,
            isSizeOrColorChange: res.isSizeOrColorChange,
            marketingQuality: res.marketingQuality,
            isLackGoodsBooking: res.isLackGoodsBooking,
            customerOrderNo: res.customerOrderNo,
          };
          let index = this.tabList.findIndex((item) => {
            return item.id === "1";
          });
          if (res.storeInfo && res.storeInfo.length) {
            let list = []
            if(res.couponInfoList && res.couponInfoList.length) {
              res.couponInfoList.forEach(item=>{
                if([1, 2].includes(item.couponType)){
                  let obj = {
                    ...item,
                    goodsNature: '1',
                    dataType: 'other'
                  }
                  list.push(obj)
                }
              })
            }
            this.newGoodsInfos = [...res.storeInfo, ...list]
            if (index === -1) {
              this.tabList.splice(1, 0, { name: this.$t('salesRecord.lastUpdateTime'), id: "1" });
            }
          } else {
            if (index !== -1) {
              this.tabList.splice(index, 1);
            }
          }
          GridManager.refreshGrid(this.gridOption1.gridManagerName);
          let afterIdx = this.tabList.findIndex((item) => {
            return item.id === "8";
          });
          if (
            res.queryOrderAfterSalesPojos &&
            res.queryOrderAfterSalesPojos.length
          ) {
            this.aftersalesInfo = res.queryOrderAfterSalesPojos;
            this.showList.hasAftersalesInfo = "Y";
            if (afterIdx === -1) {
              this.tabList.push({
                id: "8",
                name: this.$t('salesRecord.afterSalesInfo'),
              });
            }
          } else {
            if (afterIdx !== -1) {
              this.tabList.splice(afterIdx, 1);
            }
          }

          if (res.queryBookingApplyPojos.length) {
            this.bookingApplyList = res.queryBookingApplyPojos;
            this.showList.hasBookingInfo = "Y";
            let indexTab = this.tabList.findIndex((item) => {
              return item.id === "10";
            });
            if (indexTab === -1) {
              this.tabList.push({
                name: this.$t('salesRecord.customOrderInfo'),
                id: "10",
              });
            }
          } else {
            if (indexTab !== -1) {
              this.tabList.splice(indexTab, 1);
            }
            // this.bookingApplyList = [];
          }
          this.domArray = [];
          this.$nextTick(() => {
            this.tabList.forEach((item, index) => {
              this.domArray.push({
                label: item.name,
                id: item.id,
              });
            });
            this.domArray.map((item) => {
              let dom = document.querySelector(`#tabcont${item.id}`);
              if (dom) {
                item.top = dom.offsetTop;
              }
            });
          });

        })
        .catch((error) => {
          GridManager.refreshGrid(this.gridOption1.gridManagerName);
        });
    },
    exchangeHandel(type) {
      if (type === "1") {
        this.invoicesItem = {
          id: this.ordingData.id,
          orderTypeId: this.ordingData.orderTypeCode || "1",
        };
        queryBookingApplyPojo({
          id: this.ordingId,
        })
          .then((data) => {
            this.bookingApplyList = data;
            let falg = false;
            this.bookingApplyList?.map((item) => {
              if (item.state == 2) {
                return this.$message({
                  showClose: true,
                  message: this.$t('salesRecord.orderMatchedShipped'),
                  type: "error",
                  duration: 2000,
                });
              }
              if (item.state == 0 || item.state == 1) {
                falg = true;
                return this.$message({
                  showClose: true,
                  message: this.$t('salesRecord.pleaseCloseCustomOrder'),
                  type: "error",
                  duration: 2000,
                });
              }
            });
            if (falg) {
              return;
            }
            this.returnVisible = true;
          })
          .catch((err) => {});
      } else if (type === "4") {
        this.invoicesItem = {
          id: this.ordingData.id,
          crmAmount: this.crmAmount,
          otherAmount: this.otherAmount,
          couponAmount: this.couponAmount,
          orderTypeId: this.ordingData.orderTypeCode || "1",
          marketingQuality: this.btnAction.marketingQuality,
        };
        this.allReturnVisible = true;
      } else if (type === "return") {
        this.invoicesItem = {
          id: this.ordingData.id,
          isUpdate: "Y",
        };
        this.isReturnFunction(this.invoicesItem);
      } else if (type === "noReturn") {
        this.invoicesItem = {
          id: this.ordingData.id,
          isUpdate: "N",
        };
        this.isReturnFunction(this.invoicesItem);
      } else {
        this.invoicesItem = {
          type: type,
          id: this.ordingData.id,
          orderTypeId: this.ordingData.orderTypeCode || "1",
        };
        this.exchangeVisible = true;
      }
    },
    isReturnFunction(obj) {
      this.$confirm(obj.isUpdate === "Y" ? this.$t('salesRecord.confirmReturnGoods') : this.$t('salesRecord.confirmCancelReturn'), this.$t('salesRecord.tips'))
        .then(() => {
          this.infoDetailLoading = true;
          confirmedReturnOrder({
            id: obj.id,
            isUpdate: obj.isUpdate,
          })
            .then((data) => {
              if (data) {
                this.$message({
                  type: "success",
                  message: this.$t('salesRecord.operationSuccess'),
                  duration: 2000,
                  showClose: true,
                });
                this.infoDetailLoading = false;
                this.$refs.ording.queryHangList();
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
                duration: 2000,
                showClose: true,
              });
              this.infoDetailLoading = false;
            });
        })
        .catch(() => {});
    },
    sendExpressage(row) {
      this.snData = {
        invoicesId: this.ordingData ? this.ordingData.id : "",
        orderNo: this.ordingData ? this.ordingData.orderNo : "",
      };
      if (row) {
        this.snData = { ...this.snData, ...row };
      }
      this.sendVisible = true;
    },
    cancelLogistics(row) {
      this.$confirm(this.$t('salesRecord.confirmCancelExpress'), this.$t('salesRecord.tips'))
        .then((res) => {
          erpPackageRecallJdExpress({
            waybillCode: row.expressNo,
          })
            .then((res) => {
              this.queryInvoices();
              this.$message({
                type: "success",
                message: this.$t('salesRecord.expressCancelSuccess'),
                duration: 2000,
                showClose: true,
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
                duration: 2000,
                showClose: true,
              });
            });
        })
        .catch((err) => {});
    },
    showTrack(row) {
      this.trackData = {
        senderName: row.senderName,
        senderMobile: row.senderPhone,
        senderAddress: row.senderAddress,
        logisticsCompany: row.logisticsName,
        waybillNo: row.expressNo,
        queryType: row.queryType,
        queryUrl: row.queryUrl,
        logisticsCompanyId: row.logisticsId,
      };
      this.showTrackDialog = true;
    },
    refreshHandel(type) {
      if (type === 1) {
        this.returnVisible = false;
      } else if (type === 2) {
        this.exchangeVisible = false;
      } else if (type === 3) {
        this.allReturnVisible = false;
      } else {
        this.outOfStockVisible = false;
      }
      this.$refs.ording.queryHangList();
    },
    showTicketInfo(row){
      this.ticketData = row
      this.ticketDrawer = true
    }
  },
};
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  width: 100%;
  line-height: 20px;
}

.section-main {
  width: calc(100vw - 520px);
  height: calc(100vh - 80px);
  margin-top: 10px;
  position: relative;

  .bot-fixed {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    height: 60px;
    box-shadow: 0px -2px 16px 0px rgba(4, 51, 97, 0.1);
    border-radius: 2px;
    z-index: 9;

    .tools-btn {
      border-radius: 4px;
      color: #fff;
      padding: 0 10px;
      text-align: center;
      line-height: 40px;
      margin-right: 10px;
      cursor: pointer;
      background: #067cf2;
    }
  }
}

.invoice-detail {
  height: calc(100vh - 200px);
  overflow: auto;
  position: relative;
  background: #fff;
  padding: 0 20px 20px;

  .card-bottom {
    border-bottom: 1px solid #e1e1e1;
  }

  .invoice-card {
    margin-bottom: 20px;

    .goods-top {
      font-family: "font-Medium";
      color: #656d78;
      height: 50px;
      font-size: 14px;
      .title-label {
        margin-right: 10px;
        height: 20px;
        width: 4px;
        background: #067cf2;
        float: left;
        margin-top: 2px;
      }

      .title-text {
        color: #000;
        font-size: 16px;
      }

      .show-hidden {
        cursor: pointer;
        font-size: 14px;
        color: #333;
      }
    }

    .top-bottom {
      border-bottom: 1px solid #e1e1e1;
    }

    .invoice-data {
      color: #999;
      margin-top: 20px;
      font-size: 14px;

      div {
        width: calc(100% / 3);
        text-align: left;
        line-height: 30px;

        span {
          color: #000;
        }
      }

      .red-text {
        color: red;
        font-size: 18px;
        font-family: "font-Medium";
      }
    }

    .receipts-img {
      margin-left: 10px;
      margin-top: 15px;

      .webview {
        width: 100%;
        min-height: 600px;
      }
    }
  }
}
</style>
